import React from 'react'
import './styles/index.scss'
import useLoyaltyBonus from './hooks/useLoyaltyBonus'
import HtmlParser from 'react-html-parser'
import Banner from '../../components/Banner'
import LoyaltyCard from './LoyaltyCard'
import Slider from 'components/Slider/Slider'
import { SLIDE_TYPES } from 'constants/slider'
import Button from 'components/Common/Button'
import { BUTTON_VARIANT } from 'utils/constants'

const LoyaltyBonus = () => {
  const {
    loyaltyLevel,
    languageData,
    selectedLanguageCode,
    navigate
  } = useLoyaltyBonus()

  return (
    <>
      <section className='wrapper-content banner'>
        <Banner pageType='loyalty' anchorTagFilterType='loyaltyBannerBtn' />
      </section>

      <section className='reward-section container'>
        <div className='inner-heading'>
          <h2>
            {languageData?.loyaltyHeadingOne}
          </h2>
          <h3>
            {languageData?.loyaltyHeadingTwo}
          </h3>
        </div>

        <div>
          <div className='reward-card text-start'>
            <p>{languageData?.loyaltyHeadingOneDesc} </p>
          </div>
        </div>
      </section>

      <section className='loyalty-level-card-container'>
        {
          loyaltyLevel?.map((loyaltyLevelDetail, index) => {
            return (
              <LoyaltyCard key={index} loyaltyLevelDetail={loyaltyLevelDetail} languageData={languageData} />
            )
          })
        }
      </section>

      <div className='progress-btn-wrap text-center'>
        <Button
          variant={BUTTON_VARIANT.PRIMARY}
          type='button'
          className='loyalty-check-progress'
          onClick={() => navigate(`/${(selectedLanguageCode?.toLowerCase())}/account/dashboard`, { state: { tab: 'dashboard' } })}
        >
          {HtmlParser(languageData?.checkProgress)}
        </Button>
      </div>

      <section className='testimonial-wrapper'>
        <div className='testomonal-section'>
          <div className='container-fluid' style={{ maxWidth: '1400px' }}>
            <div className='testimonial-container'>
              <div className='testimonial-image-wrapper'>
                <img className='testimonial-image' loading='lazy' src={languageData?.loyaltyPageSideImg} alt='Heart' />
              </div>
              <div className='testimonial-content-wrapper'>
                <div className='testimonial-content'>
                  <span className='testimonial-subheading'>{languageData?.loyaltyTestimonialHeadOne}…</span>
                  <h2 className='testimonial-heading'>{languageData?.loyaltyTestimonialHeadTwo}!</h2>
                </div>
                <p className='testimonial-description'>{languageData?.loyaltyTestimonialDesc}!</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='wrapper-content bonuspage'>
        <section className='progression-section bonuspage'>
          <div>
            <div className='inner-heading'>
              <h2>
                {languageData?.loyaltyHeadingFour}
              </h2>
            </div>
            <div className='progression-card-wrap'>
              <Slider
                slides={loyaltyLevel}
                type={SLIDE_TYPES.LOYALTY_CARDS}
                controlPosition='left_right'
                loop={false}
                sliderCard={({
                  index,
                  game: item
                }) => (
                  <div className='progression-card loyalty-slick-slide' key={`loyalty-bonus-listing ${index}`}>
                    <div className='progression-top'>
                      <span>{item?.endPoint} {languageData?.loyaltyPoints}</span>
                      <h3>{languageData?.headerLevel} {item?.level}</h3>
                    </div>
                    <div className='progression-bottom'>
                      <span>{languageData?.loyaltyCashback}:</span>
                      <h3>{Math.floor(item?.cashback_multiplier * 100)}%</h3>
                      <div className='progress'>
                        <div
                          className='progress-bar'
                          style={{ width: `${Math.floor(item?.cashback_multiplier * 100)}%` }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              />
              {/* TODO: Duplicate code for the buttons. Create a renderCheckProgress funtion button and reuse it */}
              <div className='progress-btn-wrap text-center'>
                <Button
                  variant={BUTTON_VARIANT.PRIMARY}
                  type='button'
                  className='loyalty-check-progress'
                  onClick={() => navigate(`/${(selectedLanguageCode?.toLowerCase())}/account/dashboard`, { state: { tab: 'dashboard' } })}
                >
                  {HtmlParser(languageData?.checkProgress)}
                </Button>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  )
}

export default LoyaltyBonus
